module.exports = "/assets/hero-rw-mobile.png?otypTuL";